/**
 * Site Loader
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'loader';

class Loader extends Component {
    // Elements
    elements = { body: document.body };

    // State & Util
    isLoading = () => this.elements.body.classList.contains('loading');
    loadingAnimationMS = 350;

    /**
     * Loading Toggles
     */
    showLoader = () => {
        document.body.classList.add('loading');
        setTimeout(() => this.element.classList.add('active'), 1);
    };

    hideLoader = () => {
        this.element.classList.remove('active');
        setTimeout(() => document.body.classList.remove('loading'), this.loadingAnimationMS);
    };

    toggleLoader = () => {
        if(this.isLoading()) {
            this.hideLoader();
        } else {
            this.showLoader();
        }
    };

    /*
     * Event Listeners
     */
    addEventListeners = () => {

    };

    // Initialize Component
    init() {
        window.addEventListener('toggle-loading', this.toggleLoader);
        window.addEventListener('show-loading', this.showLoader);
        window.addEventListener('hide-loading', this.hideLoader);
    }
}

registerComponent(`.${componentName}`, Loader);
